// HS Form Context
import * as React from 'react';

import { Sanitized } from '../@types/sanitized';
import { PriceSummary } from '../classes/priceSummary/PriceSummary';
import { CampaignProduct } from '../classes/campaignProduct/CampaignProduct';
import { StripeCheckoutContext } from './StripeCheckoutContext';
import { BillingContext } from './BillingContext';
import { GenericContextHandlers } from './GenericContext';
import { CurrencyType } from '../helpers/currencyHelpers';

export type SubscribeSaveContextHandlers = StripeCheckoutContext &
    Partial<BillingContext> &
    Partial<GenericContextHandlers> & {
        contextType: 'agent';
        isSubAndSave: boolean;
        customerShortCode: string;
        customerBrandingColors?: Sanitized.customerBrandingColorsObject;
        priorChosenSpendRatio: Sanitized.spendRatioObject;
        setDiscountPercentage: (discount: number) => void;
        setSelectedCampaignMediaType: (id: number) => void;
        priceSummary?: PriceSummary;
        priceMatrix?: CampaignProduct[];
        retailPriceMatrix?: CampaignProduct[];
        cartItem: Sanitized.CartItem;
        subscribeToNewListings: boolean;
        subscribeToOpenHouses: boolean;
        subscribeToPriceReductions: boolean;
        subscribeToJustSold: boolean;
        item_size: number;
        agentID: string;
        current_discount: number;
        customerGetsSSDiscount: boolean;
        duration_in_seconds: number;
        campaign_media_type_id: number;
        isSubscribedToAutomateSave: boolean;
        supportsPriceReduced: boolean;
        supportsJustSolds: boolean;
        subscribeAndSaveSettingsData?: Sanitized.subscribeAndSaveDataObject;
        hasNextdoorSupport: boolean;
        currency: CurrencyType;
        disableUI: boolean;
        isHelixStyle?: boolean;
    };

const SubscribeSaveContext = React.createContext<Partial<SubscribeSaveContextHandlers>>({
    isSubAndSave: false,
});

export const useSubscribeSaveContext = (): Partial<SubscribeSaveContextHandlers> =>
    React.useContext(SubscribeSaveContext);

export default SubscribeSaveContext;
